import React from "react";

/**
 * Twelve illustrated faces to pick from — or your own photo (a 256px square the
 * browser crops before it ever leaves the page, stored inline on the account).
 */
export const AVATAR_KEYS = Array.from({ length: 12 }, (_, i) => `a${i + 1}`);

const B = "https://static.prod-images.emergentagent.com/jobs/197785e1-d136-46de-b201-8c05d488a2e5/images";
const FACES = {
  a1: `${B}/c2895630ab8b7a4d90d47140a36833884a0eee33f6c150d590ec63693c97c6b4.jpeg`,
  a2: `${B}/75b3f1cddd2fd36badb975965d54dd9718b1a1784a632f28ec86ec24c15eb216.jpeg`,
  a3: `${B}/d6253209053b223ca19cc1c9d7339c0752f316b09043503ae789d45e26c86878.jpeg`,
  a4: `${B}/c316ab71dacc548bd413fd96d88ec751057c96e80d94dd5b0879fc190f566e25.jpeg`,
  a5: `${B}/7304b4f0df563762c09e7b0dc45bf8d6a1c5539d2a024c39bb50be9eb1f5ae72.jpeg`,
  a6: `${B}/f9be01a141ed282bc8088d389399c7df14517848d3eb1d7679126fe740a5b3a7.jpeg`,
  a7: `${B}/60623757b5f03c65184372286f9639caeac47e4ce7ab5cdbbbbdd7e06c95651b.jpeg`,
  a8: `${B}/9923ddb7ed74601ffb92874b1b4953d16f1fd167bd03d3ee32c35b1c87ff5246.jpeg`,
  a9: `${B}/8a48688c9f5f14388d9b4f75ab2e03cf25d51d677d7ace52a1982e090f2c2854.jpeg`,
  a10: `${B}/31e210d0b3a88114d328daa9cd91ea4b5b59efce6fc1c15695a1663d20ea26fb.jpeg`,
  a11: `${B}/34d8d775005b209db761fc9f3f3ab1bd7515485f82db913e9b2bd35ba37b76aa.jpeg`,
  a12: `${B}/f13dbee090e45b57a343f58071c44b2d9982a3f0829c80ca8524303d221fac89.jpeg`,
};

export const isCustomAvatar = (v) =>
  typeof v === "string" && (v.startsWith("data:image/") || v.startsWith("http"));

const initialsOf = (name, email) => {
  const src = (name || "").trim() || (email || "").split("@")[0] || "?";
  const parts = src.split(/[\s._-]+/).filter(Boolean);
  return ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase() || src[0].toUpperCase();
};

export default function Avatar({ seed, name, email, size = 28, ring = false, testid }) {
  const src = isCustomAvatar(seed) ? seed : FACES[seed];
  return (
    <span
      className="inline-flex items-center justify-center shrink-0 overflow-hidden"
      style={{
        width: size, height: size, borderRadius: size,
        background: src ? "rgba(15,18,38,0.06)" : "rgba(64,96,255,0.14)",
        boxShadow: ring ? "0 0 0 2px rgba(255,255,255,0.9), 0 2px 8px rgba(15,18,38,0.16)" : undefined,
      }}
      data-testid={testid}
      title={name || email || "Profile"}
    >
      {src ? (
        <img src={src} alt="" loading="lazy" draggable={false}
          style={{ width: size, height: size, objectFit: "cover", display: "block" }} />
      ) : (
        <span style={{ fontSize: Math.max(10, size * 0.38), fontWeight: 700, color: "#4060FF" }}>
          {initialsOf(name, email)}
        </span>
      )}
    </span>
  );
}
